import {
  ProductCompleteBox,
  ProductCompleteWrapper,
} from "./styles/product-complete";

import { ProductCompleteButton } from "./styles/product-complete";

const ProductComplete = ({ onClose }: { onClose: () => void }) => {
  return (
    <ProductCompleteWrapper>
      <ProductCompleteBox>
        <div>
          주문이 <br />
          완료 되었습니다.
        </div>
        <ProductCompleteButton onClick={onClose}>확인</ProductCompleteButton>
      </ProductCompleteBox>
    </ProductCompleteWrapper>
  );
};

export default ProductComplete;
